import { Download, Laptop, Smartphone, Apple, CheckCircle2, Clock } from "lucide-react";

export const PLATFORM_META = {
  windows: { label: "Windows", ext: ".exe", icon: Laptop, color: "#38bdf8", hint: "Windows 10 / 11 (64 bits) — installation classique, mise à jour automatique." },
  android: { label: "Android", ext: ".apk", icon: Smartphone, color: "#4ade80", hint: "Tablettes & téléphones Android 8+. Autorisez « sources inconnues » lors de l'installation." },
  mac: { label: "macOS", ext: ".dmg", icon: Apple, color: "#e2e8f0", hint: "macOS 12+ (Intel & Apple Silicon)." },
};

export function formatBytes(n) {
  if (!n) return "";
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} Ko`;
  return `${(n / 1024 / 1024).toFixed(1)} Mo`;
}

export function detectOS() {
  const ua = navigator.userAgent || "";
  if (/android/i.test(ua)) return "android";
  if (/iphone|ipad|ipod/i.test(ua)) return "ios";
  if (/windows/i.test(ua)) return "windows";
  if (/mac os x|macintosh/i.test(ua)) return "mac";
  return "other";
}

/** Carte de téléchargement d'une plateforme (Windows / Android / macOS). */
export function AppReleaseCard({ platform, release, recommended, fallback, children }) {
  const meta = PLATFORM_META[platform];
  const Icon = meta.icon;
  const href = release ? (release.download_url.startsWith("http") ? release.download_url : `${process.env.REACT_APP_BACKEND_URL}${release.download_url}`) : null;
  return (
    <div className={`relative bg-[#14101c] border rounded-2xl p-5 flex flex-col ${recommended ? "border-[#f7c935]/60 shadow-[0_0_0_1px_rgba(247,201,53,0.25)]" : "border-white/10"}`} data-testid={`release-card-${platform}`}>
      {recommended && <span className="absolute -top-2.5 left-4 px-2 py-0.5 rounded-full bg-[#f7c935] text-[#14101c] text-[10px] font-black uppercase tracking-wide" data-testid={`release-recommended-${platform}`}>Votre appareil</span>}
      <div className="flex items-center gap-2 mb-1"><Icon className="w-5 h-5" style={{ color: meta.color }} /><h2 className="font-black text-white">{meta.label}</h2></div>
      <p className="text-xs text-slate-400 mb-4 flex-1">{meta.hint}</p>
      {release ? (
        <div className="space-y-2">
          <a href={href} className="inline-flex w-full items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-[#f7c935] text-[#14101c] text-sm font-black hover:brightness-110 transition" data-testid={`release-download-${platform}`}>
            <Download className="w-4 h-4" /> Télécharger pour {meta.label} ({meta.ext})
          </a>
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-slate-400" data-testid={`release-meta-${platform}`}>
            <span className="inline-flex items-center gap-1 text-emerald-400 font-bold"><CheckCircle2 className="w-3 h-3" /> v{release.version}</span>
            {release.size ? <span>{formatBytes(release.size)}</span> : null}
            <span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" /> {new Date(release.created_at).toLocaleDateString("fr-FR")}</span>
          </div>
          {release.notes && <p className="text-[11px] text-slate-500 whitespace-pre-line" data-testid={`release-notes-${platform}`}>{release.notes}</p>}
          {children}
        </div>
      ) : (
        <div className="space-y-2" data-testid={`release-empty-${platform}`}>
          <div className="text-xs text-slate-500 italic">Aucune version publiée pour le moment.</div>
          {fallback}
          {children}
        </div>
      )}
    </div>
  );
}
